import type { RouteObject } from 'react-router'

import { SupportPage } from '@/features/support/SupportPage'

export const routes: RouteObject[] = [{ path: 'support', element: <SupportPage /> }]
